// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9404) return "static/css/9404.80ef3ec7c482494b2623.css";
	// return url for filenames based on template
	return "static/css/" + {"7494":"css","8024":"reset"}[chunkId] + "." + {"7494":"5c62b76e9df85fe9fdf6","8024":"9194cbe22c9eec7fe2d6"}[chunkId] + ".css";
};